import * as betprofessor from './NoRaces.styles.betprofessor';
import * as betroyale from './NoRaces.styles.betroyale';
import * as fiestabet from './NoRaces.styles.fiestabet';
import * as puntcity from './NoRaces.styles.puntcity';
import * as puntgenie from './NoRaces.styles.puntgenie';
import * as questbet from './NoRaces.styles.questbet';
import * as vikingbet from './NoRaces.styles.vikingbet';
import * as volcanobet from './NoRaces.styles.volcanobet';
import * as wellbet from './NoRaces.styles.wellbet';
import * as juicybet from './NoRaces.styles.juicybet';
import * as sterlingparker from './NoRaces.styles.sterlingparker';
import * as goldenrush from './NoRaces.styles.goldenrush';
import * as forsport from './NoRaces.styles.forsport';
import * as junglebet from './NoRaces.styles.junglebet';
import * as sugarcastle from './NoRaces.styles.sugarcastle';
import * as oldgill from './NoRaces.styles.oldgill';
import * as buffalobet from './NoRaces.styles.buffalobet';
import * as titanbet from './NoRaces.styles.titanbet';
import * as slambet from './NoRaces.styles.slambet';
import * as gigabet from './NoRaces.styles.gigabet';
import * as betstride from './NoRaces.styles.betstride';
import * as templebet from './NoRaces.styles.templebet';
import * as goldenbet888 from './NoRaces.styles.goldenbet888';
import * as hyperbet from './NoRaces.styles.hyperbet';
import * as bet777 from './NoRaces.styles.bet777';
import * as chromabet from './NoRaces.styles.chromabet';
import * as bet575 from './NoRaces.styles.bet575';
import * as betblast from './NoRaces.styles.betblast';
import * as pyramidbet from './NoRaces.styles.pyramidbet';
import * as magnumbet from './NoRaces.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  sterlingparker,
  goldenrush,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
